import View from './view';

export default View.extend( {

    template: 'jst/file.uploading.badge',

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        options.uploading.then( () => this.done_ = true, e => this.error_ = e )
            .then( () => this.render() );

        this.done_ = false;
        this.error_ = null;
    },

    serialize() {
        return {
            active: !this.done_ && !this.error_,
            done: this.done_,
            error: this.error_
        }
    }
} );


// WEBPACK FOOTER //
// ./src/js/view/file.badge.uploading.js